<template lang="pug">
  .trace-events
    GenericTable()
      tr(slot="thead")
        th(colspan="7") Event History
      tr(slot="thead")
        th Type
        th Location
        th Disposition
        th Business Step
        th Time
        th User
        th
      tr(v-for="e in events", :class="{'text-muted' : e.implicit}")
        td(:title="e.type | event")
          i(:class="`fa icon-event-${e.type}`")
        td
          span(v-if="e.location")
            FamFlag(v-if="e.location.country.code" :code="e.location.country.code")
            router-link.ml5(:to="{ name: 'byPackageType', params: { id: e.location.id } }") {{ e.location.name }}
        td {{ e.disposition | disp }}
        td {{ e.bizStep | bizStep }}
        td {{ e.eventTime | date }}
        td {{ e.user.username }}
        td
          a.ml5.btn-download(v-if="hasPackingChanges(e)", :href='packingDataFileContent(e)', :download='\'packing items \'+e.eventTime+\'.txt\'')
          a.btn-with-icon.ml5(title="download metadata file", v-if="e.hasMetadata", :href="`/ssp/supplychain/v1/events/${e.id}/metadata?download=true`")
            i.fa.fa-code

</template>

<script>
import GenericTable from '@/components/common/GenericTable'
import { eventTypeFilter, dateFilter } from '@/filters/filters'
import { bizStepFilter, dispositionFilter } from '@/components/pages/trackntrace/utils'
import FamFlag from '@/components/common/FamFlag'

export default {
  props: {
    events: {
      type: Array,
      required: true
    }
  },
  methods: {
    hasPackingChanges(event) {
      return event.attachChildren || event.detachChildren
    },
    packingDataFileContent(event) {
      const content = [`event time: ${event.eventTime}`]
      if (event.attachChildren) {
        content.push(`attached: ${event.attachChildren.child.join()}`)
      }
      if (event.detachChildren) {
        content.push(`detached: ${event.detachChildren.child.join()}`)
      }
      return `data:text/plain;charset=utf-8,${encodeURIComponent(content.join('\r\n'))}`
    }
  },
  components: {
    GenericTable,
    FamFlag
  },
  filters: {
    event: eventTypeFilter,
    date: dateFilter,
    bizStep: bizStepFilter,
    disp: dispositionFilter
  }
}
</script>

<style lang="scss">
.trace-events {
  .btn-with-icon {
    color: #8d8d8d;
  }

  .btn-with-icon > i {
    width: 0px;
    margin-left: -6px;
  }

  .icon-event-AggregationEvent:before {
    content: "\F16B";
  }

  .icon-event-ObjectEvent:before {
    content: "\F06E";
  }

  .icon-event-TransactionEvent:before {
    content: "\f0ec";
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/trace/components/EventDetails.vue